<template>
  <div>
    <menu-bar></menu-bar>
    <el-main style="width: 1150px;margin: 0 auto;">
<!--      <el-button type="primary" size="small" @click="clearCache">清除缓存</el-button>-->
      <el-card v-if="!loading" style="margin-top: 12px">
        <div style="margin-bottom: 12px;display: flex;justify-content: space-between">
          <div style="display: flex;align-items: center">
            <el-input style="width: 220px;margin-left: 40px" size="small" v-model="filterName" @input="filterItem"></el-input>
            <el-select v-model="sortType" placeholder="请选择" size="small" style="display: inline-block;margin-left: 8px"
                       @change="applySort">
              <el-option
                v-for="item in sortOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <div style="font-size: 13px;margin-left: 8px">
              <el-checkbox v-model="selectAll" @change="selectAllItems">全选</el-checkbox>
            </div>
          </div>
          <div style="display: flex;align-items: center">
            <div style="margin-left: 12px;font-size: 13px;margin-right: 12px">
              <div>
                总价值 {{ computedTotalReferencePrice }} ￥
              </div>
<!--              <div>-->
<!--                已选择 {{ selectedItem.length }} 件-->
<!--              </div>-->
            </div>
<!--            <el-button size="small" type="primary" @click="showSteamSellingModal">-->
<!--              上架Steam市场-->
<!--            </el-button>-->
          </div>
        </div>
        <div class="inventoryContainer">
          <div v-if="inventories.length !== 0" class="item_container" style="text-align: center">
<!--            @click="selectInventoryItem(inventoryItem)"-->
            <div v-for="(inventoryItem,index) of inventories"
                 style="display: inline-block;vertical-align:top"
            >
              <div :class="inventoryItem.selected ? 'inventorySelected':''" class="item-floating-details">
                <div class="item-floating-details__body">
                  <div class="item-floating-details__main">
                    <div class="item-floating-details__top">
                      <div class="base-tooltip">
                        <div class="base-tooltip__activator tooltip-activator">
                          <div>
                            <div class="item-floating-730-label item-floating-details__label">
                              <span class="item-floating-730-label__small">
                              <div style="display: flex">
                                <div
                                  style="z-index: 999;flex: 1;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;cursor: pointer"
                                  v-clipboard="$i18n.locale === 'zh' ?  inventoryItem.cnName:inventoryItem.engName"
                                >
                                  {{
                                    formatterLocalName(inventoryItem)
                                  }}
                                </div>
                              </div>
                            </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <img :alt="inventoryItem.engName"
                         data-type="SMG"
                         :src="inventoryItem.icon_url"
                         :style="checkAddable(inventoryItem) ? 'opacity: .3':''"
                         class="item-floating-details__image">
                    <div style="position: absolute;bottom: 30px;width: 100%;display: flex">
                      <div style="flex: 1">
                        <!--                        <el-tag type="info" style="float: left" size="small">-->
                        <!--                          {{ inventoryItem.disCount == null ? '' : inventoryItem.disCount.toFixed(3) }}-->
                        <!--                        </el-tag>-->
                        <el-tag v-if="inventoryItem.rarityName" size="small" type="info"
                                style="float: right;max-width: 85px;"
                                :style="formatterRarity(inventoryItem.rarityName)">
                          {{ formatterLocalRarityName(inventoryItem) }}
                        </el-tag>
                      </div>
                    </div>

                    <div class="item-details-row-light" style="height: 20px;margin-bottom: 8px;">
                      <span class="item-details-row__label">
                        <el-tag v-if="regexWear(inventoryItem.engName)" size="small" type="info"
                                :style="formatterWear(inventoryItem)" style="opacity: 0.9">
                          {{ $t(regexWear(inventoryItem.engName)) }}
                        </el-tag>
                      </span>
                      <span class="item-details-row__value">
                        <el-tag size="small" type="info" style="opacity: 0.9;float: right">
                          {{
                            formatterPrice(inventoryItem.minPrice)
                          }}
                        </el-tag>
                      </span>
                    </div>
                  </div>
                </div>
                <div v-if="sortType == 'disCountAsc'" class="divButton" plain size="small" style="width: 180px;padding: 9px">
                  <div style="display: flex;align-items: center;">
                    <div style="min-width: 80px">
                      Steam寄售价格
                    </div>
                    <div style="margin-left: 8px;line-height: 20px">
                      <div style="min-width: 55px;display: inline-block">
                        {{ formatterPrice(inventoryItem.steamSellerPrice) }}
                      </div>
                    </div>
                  </div>
                  <div style="display: flex;align-items: center;margin-top: 8px">
                    <div style="min-width: 80px">
                      税后折扣
                    </div>
                    <div style="line-height: 20px;flex: 1;text-align: center">
                      <el-tag v-if="inventoryItem.minPrice && inventoryItem.steamSellerPrice" size="mini"
                              :type="formatterSoldDisCountColor(inventoryItem.minPrice / inventoryItem.steamSellerPrice / 0.87)">
                        {{
                          (inventoryItem.steamSellerPrice == null || inventoryItem.minPrice == null) ? '' : (inventoryItem.minPrice / inventoryItem.steamSellerPrice).toFixed(3)
                        }}
                      </el-tag>
                    </div>
                  </div>
                </div>
                <div v-if="sortType == 'buyOrderDisCountAsc'" class="divButton" plain size="small" style="width: 180px;padding: 9px">
                  <div style="display: flex;align-items: center;">
                    <div style="min-width: 80px">
                      Steam求购价格
                    </div>
                    <div style="margin-left: 8px;line-height: 20px">
                      <div style="min-width: 55px;display: inline-block">
                        {{ formatterPrice(inventoryItem.steamBuyerPrice) }}
                      </div>
                    </div>
                  </div>
                  <div style="display: flex;align-items: center;margin-top: 8px">
                    <div style="min-width: 80px">
                      税后折扣
                    </div>
                    <div style="line-height: 20px;flex: 1;text-align: center">
                      <el-tag v-if="inventoryItem.minPrice && inventoryItem.steamBuyerPrice" size="mini"
                              :type="formatterSoldDisCountColor(inventoryItem.minPrice / inventoryItem.steamBuyerPrice / 0.87)">
                        {{
                          (inventoryItem.steamBuyerPrice == null || inventoryItem.minPrice == null) ? '' : (inventoryItem.minPrice / inventoryItem.steamBuyerPrice).toFixed(3)
                        }}
                      </el-tag>
                    </div>
                  </div>
                </div>
                <div v-if="sortType == 'avgDisCountAsc'" class="divButton" plain size="small" style="width: 180px;padding: 9px">
                  <div style="display: flex;align-items: center;">
                    <div style="min-width: 80px">
                      近期成交
                    </div>
                    <div style="margin-left: 8px;line-height: 20px">
                      <div style="min-width: 55px;display: inline-block">
                        {{ formatterPrice(inventoryItem.avgPrice) }}
                      </div>
                    </div>
                  </div>
                  <div style="display: flex;align-items: center;margin-top: 8px">
                    <div style="min-width: 80px">
                      税后折扣
                    </div>
                    <div style="line-height: 20px;flex: 1;text-align: center">
                      <el-tag v-if="inventoryItem.minPrice && inventoryItem.avgPrice" size="mini"
                              :type="formatterSoldDisCountColor(inventoryItem.minPrice / inventoryItem.avgPrice / 0.87)">
                        {{
                          (inventoryItem.avgPrice == null || inventoryItem.minPrice == null) ? '' : (inventoryItem.minPrice / inventoryItem.avgPrice).toFixed(3)
                        }}
                      </el-tag>
                    </div>
                  </div>
                </div>
                <div v-if="sortType == 'priceDesc' || sortType == 'priceAsc' || sortType == 'default' || sortType == 'recommendSoldOnDMarket' || sortType == 'recommendSoldOnBuff'" class="divButton" plain size="small" style="width: 180px;padding: 9px">
                  <div style="display: flex;align-items: center;">
                    <div style="min-width: 80px">
                      <i style="margin-right: 4px" class="icon-buff iconfont icon-guanfangmeiti mr-5 text-26"></i>
                      求购价格:
                    </div>
                    <div style="margin-left: 8px;line-height: 20px">
                      <div style="min-width: 55px;display: inline-block">
                        {{ formatterPrice(inventoryItem.buffBuyerPrice) }}
                      </div>
                    </div>
                  </div>
                  <div style="display: flex;align-items: center;margin-top: 8px">
                    <div style="min-width: 80px">
                      <i style="margin-right: 4px" class="icon-dmarket iconfont icon-guanfangmeiti mr-5 text-26"></i>
                      求购价格:
                    </div>
                    <div style="margin-left: 8px;line-height: 20px">
                      <div style="min-width: 55px;display: inline-block">
                        {{ formatterPrice(inventoryItem.dmarketOrderPrice) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <h2 style="text-align: center;color:#aaaaaa;">暂无库存</h2>
          </div>
        </div>
      </el-card>
      <el-card v-else style="margin-top: 12px">
        <el-skeleton :rows="6" animated/>
        <el-skeleton :rows="6" animated/>
        <el-skeleton :rows="6" animated/>
      </el-card>
    </el-main>
    <login-dialog ref="loginDialog" @loginSuccess="getInventory"></login-dialog>
    <el-dialog
      :visible.sync="steamSellingModal"
      width="35%">
      <div>
        <el-alert
          title="参考价为第三方平台(buff/uu/c5)的最低在售价格"
          style="margin-bottom: 12px"
          type="warning"
          show-icon
          :closable="false"
        >
        </el-alert>
        <el-form ref="form" :model="pricingForm" label-width="110px">
          <el-form-item label="定价方式">
            <el-select v-model="priceOption" placeholder="定价方式">
              <el-option
                v-for="item in priceOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="税后价格" v-show="priceOption === 'SoldOnMarked'">
            <el-input v-model="pricingForm.markedPrice" placeholder="请输入税后价格" style="width: 65%"></el-input>
          </el-form-item>
          <el-form-item label="出售数量">
            <span>共 {{ selectedItem.length }} 件</span>
          </el-form-item>
          <el-form-item label="第三方参考价">
            <span>{{ totalReferencePrice }} ￥</span>
          </el-form-item>
          <el-form-item label="上架Steam金额">
            <span>{{ totalTobeSoldPrice.toFixed(2)}}</span>
            <span style="margin-left: 12px">税后到手 {{ (totalTobeSoldPrice * 0.87).toFixed(2) }}</span>
          </el-form-item>
          <el-form-item label="预计折扣">
            <el-tag v-if="totalTobeSoldPrice != null && totalTobeSoldPrice != 0" effect="plain"
                    :type="formatterTagType(totalReferencePrice/(totalTobeSoldPrice * 0.87))"
            >
              {{ (totalReferencePrice/(totalTobeSoldPrice * 0.87)).toFixed(2) }}
            </el-tag>
          </el-form-item>
        </el-form>
        <div style="text-align: center">
          <el-button size="small" type="primary" @click="confirmCreateSelling">确定</el-button>
          <el-button size="small">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  createSteamSelling,
  createSteamTargets
} from "../../api/api";
import MenuBar from "../Menu/menuBar.vue";

const {rartiyIndex} = require("../../api/util");
const {formatterWear} = require("../../api/util");
const {cloneObj} = require("../../api/util");
const {getUserInventory} = require("../../api/api");
const {formatterRarity} = require("../../api/util");
const {regexWear} = require("../../api/util");
import {currencyIconOptions, getCookie, getRefreshToken, getSteamId, mockInventory} from "../../api/util";
import i18n from "../../main";
import LoginDialog from "../Login/index.vue";

export default {
  name: "inventory",
  components: {LoginDialog, MenuBar},
  props: {
    weaponCasesIndex: Object,
    currencyOptions: Object
  },
  data() {
    return {
      filterName:'',
      backupInventories: [],
      inventories: [],
      total: 0,
      totalPrice: 0,
      buyOrderLoading: false,
      loading: false,
      selectAll: false,
      selectAllCooldown: false,
      sortType: 'default',
      sortOptions: [
        {value: 'default', label: '默认排序'},
        {value: 'priceAsc', label: '价格升序'},
        {value: 'priceDesc', label: '价格降序'},
        {value: 'buyOrderDisCountAsc', label: '推荐在Steam上出售'},
        {value: 'recommendSoldOnDMarket',label:'推荐在DMarket上出售'},
        {value: 'recommendSoldOnBuff', label: '推荐在Buff上出售'},
      ],
      steamSellingModal: false,

      pricingForm: {
        markedPrice:'', // 自己标的价格
      },
      priceOption: 'SoldOnSell',
      priceOptions: [
        {
          value: 'SoldOnSell',
          label: '以Steam售价出售'
        },
        {
          value: 'SoldOnBuy',
          label: '以Steam求购价出售'
        },
        {
          value: 'SoldOnMarked',
          label: '按输入价格出售'
        },
        {
          value: 'SoldOn0.75',
          label: '1.532倍参考价出售(挂刀比例0.75)'
        },
        {
          value: 'SoldOn0.7',
          label: '1.642倍参考价出售(挂刀比例0.7)'
        },
        {
          value: 'SoldOn0.65',
          label: '1.768倍参考价出售(挂刀比例0.65)'
        },
        {
          value: 'SoldOn0.6',
          label: '1.915倍参考价出售(挂刀比例0.6)'
        }
      ]
    }
  },
  computed: {
    computedTotalReferencePrice(){
      let totalPrice = 0
      for (let item of this.selectedItem){
        totalPrice += item.minPrice || 0
      }
      return totalPrice.toFixed(2)
    },
    formatterLocalName() {
      return function (item) {
        let lang = localStorage.getItem("selectedLanguage")
        if (lang === 'en') {
          return item.engName
        } else {
          return item.cnName
        }
      }
    },
    selectedItem() {
      let arr = []
      for (let item of this.inventories) {
        if (item.selected) {
          arr.push(item)
        }
      }
      return arr
    },
    totalTobeSoldPrice(){
      let amount = 0
      for (let item of this.inventories) {
        if (item.selected) {
          amount += this.calculatePrice(item) / 0.87 / 100
        }
      }
      return amount
    },
    totalReferencePrice() {
      let amount = 0
      for (let item of this.inventories) {
        if (item.selected) {
          amount += item.minPrice
        }
      }
      return amount == null ? 0:amount.toFixed(2)
    }
  },
  methods: {
    filterItem(val){
      if (val !== ''){
        let arr = []
        for (let inventory of this.backupInventories){
          if (inventory.name.indexOf(val) !== -1 || inventory.engName.indexOf(val) !== -1){
            arr.push(inventory)
          }
        }
        this.inventories = arr
      }else{
        this.inventories = this.backupInventories
      }
    },
    clearCache(){
      localStorage.removeItem("steamId")
      localStorage.removeItem("cookies")

      this.$message({
        message: '清除缓存成功!',
        type: 'success'
      });

      location.reload()
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    formatterTagType(val) {
      if (val <= 0.7) {
        return 'success'
      } else if (val <= 0.8) {
        return 'primary'
      } else if (val <= 0.9) {
        return 'warning'
      } else {
        return 'danger'
      }
    },
    async confirmCreateSelling() {
      let vm = this;
      for (let i = 0; i < this.selectedItem.length; i++) {
        let item = this.selectedItem[i];
        let price = this.calculatePrice(item)
        let data = {
          assetid: item.assetid,
          appid: item.staffGame === 'csgo' ? '730' : '570',
          price: price
        };

        let json = await createSteamSelling(data);
        if (json.data.flag === 'T') {
          vm.$message({
            message: '上架成功,当前进度: ' + (i + 1) + ' / ' + this.selectedItem.length,
            type: 'success'
          });
        } else {
          vm.$message.error('上架失败,请尝试清除缓存:\n' + json.data.data);
        }

        // 等待 1 秒
        await new Promise(resolve => setTimeout(resolve, 1000));
      }

      this.steamSellingModal = false
    },
    calculatePrice(item){
      let price;
      debugger
      switch (this.priceOption) {
        case "SoldOnSell":
          price = Math.floor(item.steamSellerPrice * 100);
          break;
        case "SoldOnBuy":
          price = Math.floor(item.steamBuyerPrice * 100);
          break;
        case "SoldOnMarked":
          price = this.pricingForm.markedPrice == null ? 0:this.pricingForm.markedPrice * 100
          break;
        case "SoldOn0.75":
          price = Math.floor(item.minPrice / 0.75 * 100);
          break;
        case "SoldOn0.7":
          price = Math.floor(item.minPrice / 0.7 * 100);
          break;
        case "SoldOn0.65":
          price = Math.floor(item.minPrice / 0.65 * 100);
          break;
        case "SoldOn0.6":
          price = Math.floor(item.minPrice / 0.6 * 100);
          break;
      }

      return price.toFixed(0);
    },
    isAdmin() {
      let steamId = this.$store.getters.getUserInfo.steamId
      if (steamId === '76561198220126577') {
        return true
      } else {
        return false
      }
    },
    createSteamTargets() {
      createSteamTargets({balance: this.$store.getters.getUserInfo.wallet.balance}).then(json => {

      })
    },
    triggerSteamLogin() {
      this.$refs.loginDialog.loginDialog = true
    },
    selectInventoryItem(item) {
      console.log('click!')
      this.$set(item, 'selected', !item.selected)
    },
    showSteamSellingModal() {
      this.steamSellingModal = true
    },
    selectAllItems() {
      for (let item of this.inventories) {
        this.$set(item, 'selected', this.selectAll)
      }
    },
    selectAllCooldownItems() {
      for (let item of this.inventories) {
        if (this.checkAddable(item)) {
          this.$set(item, 'selected', this.selectAllCooldown)
        }
      }
    },
    applySort() {
      let arr = []
      this.inventories = this.backupInventories
      switch (this.sortType) {
        case "default":
          break;
        case "priceAsc":
          this.inventories.sort(function (a, b) {
            return a.minPrice - b.minPrice
          })
          break;
        case "priceDesc":
          this.inventories.sort(function (a, b) {
            return b.minPrice - a.minPrice
          })
          break;
        case "disCountAsc":
          this.inventories.sort(function (a, b) {
            return a.disCount - b.disCount
          })
          break;
        case "buyOrderDisCountAsc":
          for (let row of this.inventories){
            if (row.steamBuyerPrice != null && row.steamBuyerPrice * 0.7 >= row.minPrice){
              arr.push(row)
            }
          }
          this.inventories = arr.sort(function (a, b) {
            return  (a.minPrice / a.steamBuyerPrice) - (b.minPrice / b.steamBuyerPrice)
          })
          break;
        case "avgDisCountAsc":
          this.inventories.sort(function (a, b) {
            return (a.minPrice / a.avgPrice) - (b.minPrice / b.avgPrice)
          })
          break;
        case "recommendSoldOnDMarket":
          for (let row of this.inventories){
            if (row.dmarketOrderPrice != null && row.dmarketOrderPrice >= row.minPrice){
              arr.push(row)
            }
          }
          this.inventories = arr.sort(function (a, b) {
            return (a.minPrice / a.dmarketOrderPrice) - (b.minPrice / b.dmarketOrderPrice)
          })
          break;
        case "recommendSoldOnBuff":
          for (let row of this.inventories){
            if (row.buffBuyerPrice != null && row.buffBuyerPrice >= row.minPrice){
              arr.push(row)
            }
          }
          this.inventories = arr.sort(function (a, b) {
            return (a.minPrice / a.buffBuyerPrice) - (b.minPrice / b.buffBuyerPrice)
          })
          break;
        default:
          break;
      }
    },
    formatterDMarketPrice(item) {
      let price = 0
      if (item.dmarketOrderPrice == null) {
        return this.$t('noData')
      } else {
        price = item.dmarketOrderPrice.toFixed(3)
      }
      return this.formatterPrice(price)
    },
    routerToDMarket() {
      window.open('https://dmarket.com/zh/ingame-items/item-list/csgo-skins?exchangeTab=myItems&ref=fDuhF5X91i')
    },
    routerToHaoBan() {
      window.open('https://hbcsgo.com/100001')
    },
    formatterDisCountColor(val) {
      if (val == null || val == undefined) {
        return ''
      } else {
        if (val >= 1) {
          return 'success'
        } else if (val >= 0.8) {
          return 'primary'
        } else if (val >= 0.7) {
          return 'warning'
        } else {
          return 'danger'
        }
      }
    },
    formatterSoldDisCountColor(val) {
      if (val == null || val == undefined) {
        return ''
      } else {
        if (val <= 0.7) {
          return 'success'
        } else if (val <= 0.8) {
          return 'primary'
        } else if (val <= 1) {
          return 'warning'
        } else {
          return 'danger'
        }
      }
    },
    checkAddable(inventoryItem) {
      return !inventoryItem.tradable;
    },
    regexWear(engName) {
      return regexWear(engName)
    },
    calculateDisCount(item, val) {
      if (item.minPrice == null) {
        return null
      } else {
        return (item.minPrice / (val * 0.85)).toFixed(3)
      }
    },
    formatterLocalWeaponCaseName(val) {
      let lang = localStorage.getItem("selectedLanguage")
      if (lang === 'zh') {
        return val
      } else {
        return this.weaponCasesIndex[val] == null ? val : this.weaponCasesIndex[val]
      }
    },
    formatterRarity(val) {
      return formatterRarity(val)
    },
    formatterLocalRarityName(item) {
      let lang = localStorage.getItem("selectedLanguage")
      if (lang === 'zh') {
        return item.rarityName
      } else {
        return rartiyIndex[item.rarity]
      }
    },
    getInventory() {
      let vm = this
      this.loading = true
      getUserInventory({appId: 730, steamId: localStorage.getItem("steamId")}).then(json => {
        let total = 0
        let totalPrice = 0
        for (let item of json.data.data) {
          item.selected = false
          this.extractTradableAfter(item)
          totalPrice += item.minPrice
          total++;
        }
        vm.inventories = json.data.data
        vm.backupInventories = json.data.data
        vm.total = total
        vm.totalPrice = totalPrice
      }).catch(e => {
        // vm.$message.error('steam cookie过期!');
        // vm.clearCache()
      }).finally(_ => {
        vm.loading = false
      })
    },
    extractTradableAfter(item) {
      // 正则表达式匹配时间字符串
      const regex = /(\d{4})\s*([0-9\u4E00-\u9FA5]+)\s*(\d{1,2})\s*\((\d{1,2}):(\d{2}):(\d{2})\)\s*格林尼治标准时间\s*后可交易/;

      // 中文月份到数字月份的映射
      const monthMap = {
        '1月': '01',
        '2月': '02',
        '3月': '03',
        '4月': '04',
        '5月': '05',
        '6月': '06',
        '7月': '07',
        '8月': '08',
        '9月': '09',
        '10月': '10',
        '11月': '11',
        '12月': '12'
      };

      item.tradable = true;

      // 遍历 owner_descriptions 以查找匹配项
      if (item.owner_descriptions != undefined) {
        item.owner_descriptions.forEach(description => {
          let match = description.value.match(regex);
          if (match) {
            // 提取匹配的年月日时间
            let year = match[1];
            let month = match[2];
            let day = match[3];
            let hour = match[4].padStart(2, '0'); // 确保小时是两位数
            let minute = match[5].padStart(2, '0'); // 确保分钟是两位数
            let second = match[6].padStart(2, '0'); // 确保秒是两位数

            // 转换中文月份为数字
            let monthNumber = monthMap[month] || '01'; // 如果月份不在映射表中，默认使用 1 月

            // 处理为 "YYYY-MM-DDTHH:MM:SS" 格式
            let tradableAfter = `${year}-${monthNumber}-${String(day).padStart(2, '0')}T${hour}:${minute}:${second}Z`;

            // 塞入 item 的 tradable_after 字段
            item.tradable_after = tradableAfter;
            item.tradable = false;
          }
        });
      }

      return item;
    },
    formatterWear(inventoryItem) {
      let wearArr = inventoryItem.engName.match(/\(([^)]*)\)/)
      if (wearArr != null && wearArr !== undefined && wearArr.length > 1) {
        return formatterWear(wearArr[1])
      } else {
        return ''
      }
    },
    checkTradable(dateTimeString) {
      // 创建一个新的Date对象，传入给定的日期时间字符串
      var inputDate = new Date(dateTimeString);

      // 获取当前时间
      var currentDate = new Date();

      // 比较当前时间和给定的日期时间
      if (currentDate > inputDate || dateTimeString == null) {
        // 当前时间晚于给定的日期时间
        return false;
      } else {
        // 当前时间不晚于给定的日期时间
        return true;
      }
    },
    formatterPrice(val) {
      // 获取货币单位
      let currency = this.$store.getters.getCurrency
      let currencyOptions = this.$store.getters.getCurrencyOptions
      if (currency !== 'CNY') {
        let rate = parseFloat(currencyOptions[currency])
        let currencyIcon = currencyIconOptions[currency]
        if (currency === 'RUB' || currency === 'TRY') {
          return val == null ? null : (val / rate).toFixed(2) + " " + currencyIcon
        } else {
          return val == null ? null : currencyIcon + " " + (val / rate).toFixed(2)
        }
      } else {
        return (val == null || val == undefined) ? null : '¥ ' + parseFloat(val).toFixed(2)
      }
    }
  },
  mounted() {
    this.getInventory()
    // this.inventories = mockInventory
    // this.backupInventories = mockInventory
  }
}
</script>

<style scoped>
.item-floating-details__body {
  background-color: rgb(233, 233, 235);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, .1), 0 2px 4px -1px rgba(0, 0, 0, .06);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 6px 8px;
}

.item-details-box {
  background-color: #302e2a;
  border-radius: 0.25rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
  font-size: .75rem;
  padding: 1rem;
  height: 100px;
}

.item-details-row__label {
  color: #aea89b;
  width: 65%;
}

.item-details-row__value {
  flex: 1;
  text-align: center;
}

.item-floating-details__image {
  height: 95px;
  margin: -0.5rem auto 0.5rem;
  -o-object-fit: scale-down;
  object-fit: scale-down;
  -o-object-position: center;
  object-position: center;
  pointer-events: none;
}

.item-floating-details__top {
  width: 100%;
}

.item-floating-details__main {
  display: flex;
  flex-direction: column;
  position: relative;
}

.item-details-paint {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.item-details-box {
  background-color: rgb(253, 246, 236);
  border-radius: 0.25rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
  font-size: .75rem;
  padding: 1rem;
}

.item-float {
  background-color: var(--float-background-color);
  display: flex;
  height: 4px;
  pointer-events: none;
  position: relative;
  width: 100%;
  z-index: 1;
  margin-bottom: 8px;
}

.item-float.large {
  margin-top: 4px;
}

.item-float.large .item-float.large .item-float__bar {
  border-radius: 2px;
  height: 6px;
}

.item-floating-details {
  width: 180px;
  margin: 8px;
  position: relative;
}

.item-float__bar {
  background: linear-gradient(90deg, #3b818f 0, #3b818f 7%, #83b135 0, #83b135 15%, #d7be47 0, #d7be47 38%, #f08140 0, #f08140 45%, #ec4f3d 0, #ec4f3d);
  -webkit-clip-path: polygon(var(--float-range-start) 0, var(--float-range-end) 0, var(--float-range-end) 100%, var(--float-range-start) 100%);
  clip-path: polygon(var(--float-range-start) 0, var(--float-range-end) 0, var(--float-range-end) 100%, var(--float-range-start) 100%);
  height: 4px;
  transition: opacity 275ms;
  width: 100%;
}

.item-details-row {
  display: flex;
  font-size: .875rem;
  justify-content: space-between;
}

.item-float__indicator {
  fill: deepskyblue;
  bottom: 4px;
  display: none;
  position: absolute;
  transition: opacity 275ms;
}

.item-float.large .item-float__indicator {
  display: block;
}

.item-floating-730-label {
  font-size: 12px;
  height: 24px;
  text-align: center;
}

.base-clipboard:hover {
  cursor: pointer;
}

.item-details-row-light {
  display: flex;
  height: 24px;
  text-align: left;
  font-size: 12px;
  align-items: center;
  margin-bottom: 2px;
}

.item-float__indicator {
  fill: #fff;
  bottom: 4px;
  display: none;
  left: -10px;
  margin-left: var(--float-value);
  position: absolute;
  transition: opacity 275ms;
}

.item-float__bar {
  background: linear-gradient(90deg, #3b818f 0, #3b818f 7%, #83b135 0, #83b135 15%, #d7be47 0, #d7be47 38%, #f08140 0, #f08140 45%, #ec4f3d 0, #ec4f3d);
  -webkit-clip-path: polygon(var(--float-range-start) 0, var(--float-range-end) 0, var(--float-range-end) 100%, var(--float-range-start) 100%);
  clip-path: polygon(var(--float-range-start) 0, var(--float-range-end) 0, var(--float-range-end) 100%, var(--float-range-start) 100%);
  height: 4px;
  transition: opacity 275ms;
  width: 100%;
}

.item-float:after {
  background-color: #fff;
  bottom: 0;
  content: "";
  height: 6px;
  left: min(var(--float-value), 100% - 1px);
  position: absolute;
  transition: opacity 275ms;
  width: 1px;
}

.inventoryContainer {
  max-height: 700px;
  overflow: auto;
}

.divButton {
  height: 68px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #FFF;
  border: 1px solid #DCDFE6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: .1s;
  transition: .1s;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 12px;
  border-radius: 4px;
}

.divButton:hover {
  cursor: default;
}


.inventorySelected {
  position: relative;
  color: #E6A23C;
}

.inventorySelected::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border: 10px solid #E6A23C;
  border-right: 10px solid transparent;
  border-bottom: 10px solid transparent;
  transition: opacity .3s;
}

.inventorySelected::after {
  content: "";
  width: 4px;
  height: 6px;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  position: absolute;
  top: 1px;
  left: 4px;
  transform: rotate(45deg);
}


.item-floating-details:hover {
  cursor: pointer;
}

@font-face {
  font-family: "iconfont"; /* Project id 4419046 */
  src: url('//at.alicdn.com/t/c/font_4419046_7f8iyeqqi1o.woff2?t=1720492860286') format('woff2'),
  url('//at.alicdn.com/t/c/font_4419046_7f8iyeqqi1o.woff?t=1720492860286') format('woff'),
  url('//at.alicdn.com/t/c/font_4419046_7f8iyeqqi1o.ttf?t=1720492860286') format('truetype'),
  url('//at.alicdn.com/t/c/font_4419046_7f8iyeqqi1o.svg?t=1720492860286#iconfont') format('svg');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-dmarket:before {
  content: "\e6d5";
}

.icon-skinport:before {
  content: "\e6d1";
}

.icon-waxpeer:before {
  content: "\e6d7";
}

.icon-csmoney:before {
  content: "\e6d4";
}

.icon-steam:before {
  content: "\e6c3";
}

.icon-c5:before {
  content: "\e6c4";
}

.icon-buff:before {
  content: "\e6c5";
}

.icon-youpin:before {
  content: "\e6c6";
}
</style>




// WEBPACK FOOTER //
// src/ui/Inventory/index.vue